import { profile, axiosConfig } from 'api';

import { BillingCompany, GetAllBillingCompanyResponse, SetCompanyStatusResponse } from 'models/billingCompany';
import { Response } from 'models/response';

export const getAllBillingCompanies = (companyId: string, status?: boolean): Promise<GetAllBillingCompanyResponse[]> =>
  profile
    .get(`/Company/GetAllBranchesCompany/${companyId}`, axiosConfig)
    .then((response) => response.data.data);

export const saveBillingCompany = async (billingCompany, companyId): Promise<BillingCompany> => {
  try {
    if (billingCompany.companyId) {
      return await (
        await profile.put<Response<BillingCompany>>(`/Company/UpdateBillingCompany/${companyId}`, {
          ...billingCompany,
          companyId: undefined,
          billingCompanyId: billingCompany.companyId,
        })
      ).data.data;
    } else {
      return await (
        await profile.post<Response<any>>('/Company/AddBranchCompany', { ...billingCompany, companyId: companyId })
      ).data.data;
    }
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

// Activa/desactiva la EMPRESA CLIENTE completa (dbo/colección Companies) y, en cascada, a todos
// sus usuarios. No confundir con `activateOrDesactivateBillingCompany`, que activa/desactiva una
// razon social de facturacion (CompanyBillingInformation) dentro de una empresa.
export const setCompanyClientStatus = async (companyId: string, isActive: boolean): Promise<SetCompanyStatusResponse> => {
  try {
    const response = await profile.put<Response<SetCompanyStatusResponse>>(`/Company/${companyId}/Status`, {
      isActive,
    });

    if (!response.data.succeeded) {
      return Promise.reject(response.data);
    }

    return response.data.data;
  } catch (error) {
    return Promise.reject(error.response ? error.response.data : error);
  }
};

export const activateOrDesactivateBillingCompany = async (
  companyId: string,
  billingCompanyId,
  isActive,
): Promise<boolean> => {
  if (isActive) {
    return profile
      .put(`/Company/AddBillingCompany/${companyId}`, {
        billingCompanyId: billingCompanyId,
      })
      .then((response) => response.data.data);
  } else {
    return profile
      .delete(`/Company/DeleteBillingCompany/${companyId}`, {
        data: { billingCompanyId: billingCompanyId },
      })
      .then((response) => response.data.data);
  }
};
